module.exports = __webpack_public_path__ + "static/2detailinfo-aa78d9ab4cc23fd94a9d8f5a13034bc7.gif";